import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lookup-management',
  templateUrl: './lookup-management.component.html',
  styleUrls: ['./lookup-management.component.css']
})
export class LookupManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/lookup-management.component.ts